/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import StudentMetaFormativeActions from './StudentMetaFormativeActions';

/**
 * The StudentMetaEnrolledAcademicPrograms model module.
 * @module model/StudentMetaEnrolledAcademicPrograms
 * @version 1.0.0
 */
class StudentMetaEnrolledAcademicPrograms {
    /**
     * Constructs a new <code>StudentMetaEnrolledAcademicPrograms</code>.
     * @alias module:model/StudentMetaEnrolledAcademicPrograms
     */
    constructor() { 
        
        StudentMetaEnrolledAcademicPrograms.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StudentMetaEnrolledAcademicPrograms</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentMetaEnrolledAcademicPrograms} obj Optional instance to populate.
     * @return {module:model/StudentMetaEnrolledAcademicPrograms} The populated <code>StudentMetaEnrolledAcademicPrograms</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentMetaEnrolledAcademicPrograms();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('formative_zone')) {
                obj['formative_zone'] = ApiClient.convertToType(data['formative_zone'], 'String');
            }
            if (data.hasOwnProperty('formative_zone_code')) {
                obj['formative_zone_code'] = ApiClient.convertToType(data['formative_zone_code'], 'String');
            }
            if (data.hasOwnProperty('modality_id')) {
                obj['modality_id'] = ApiClient.convertToType(data['modality_id'], 'Number');
            }
            if (data.hasOwnProperty('closed_academic_record')) {
                obj['closed_academic_record'] = ApiClient.convertToType(data['closed_academic_record'], 'Boolean');
            }
            if (data.hasOwnProperty('is_specialization_course')) {
                obj['is_specialization_course'] = ApiClient.convertToType(data['is_specialization_course'], 'Boolean');
            }
            if (data.hasOwnProperty('formative_actions')) {
                obj['formative_actions'] = ApiClient.convertToType(data['formative_actions'], [StudentMetaFormativeActions]);
            }
            if (data.hasOwnProperty('company_provided')) {
                obj['company_provided'] = ApiClient.convertToType(data['company_provided'], 'Boolean');
            }
            if (data.hasOwnProperty('voucher_generated')) {
                obj['voucher_generated'] = ApiClient.convertToType(data['voucher_generated'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
StudentMetaEnrolledAcademicPrograms.prototype['id'] = undefined;

/**
 * @member {String} title
 */
StudentMetaEnrolledAcademicPrograms.prototype['title'] = undefined;

/**
 * @member {String} formative_zone
 */
StudentMetaEnrolledAcademicPrograms.prototype['formative_zone'] = undefined;

/**
 * @member {String} formative_zone_code
 */
StudentMetaEnrolledAcademicPrograms.prototype['formative_zone_code'] = undefined;

/**
 * @member {Number} modality_id
 */
StudentMetaEnrolledAcademicPrograms.prototype['modality_id'] = undefined;

/**
 * @member {Boolean} closed_academic_record
 */
StudentMetaEnrolledAcademicPrograms.prototype['closed_academic_record'] = undefined;

/**
 * @member {Boolean} is_specialization_course
 */
StudentMetaEnrolledAcademicPrograms.prototype['is_specialization_course'] = undefined;

/**
 * @member {Array.<module:model/StudentMetaFormativeActions>} formative_actions
 */
StudentMetaEnrolledAcademicPrograms.prototype['formative_actions'] = undefined;






export default StudentMetaEnrolledAcademicPrograms;

